<template>
    <div class="container-fluid">
        <div class="card glass-panel mb-4">
            <div class="card-body">
                <h3>Cadastro de usuários da empresa</h3>
                <div class="dropdown-divider"></div>
                <h5>Aqui vamos cadastrar e editar toda a base de usuários internos da empresa, centralizando a informação e segmentando os colaboradores de acordo com suas atribuições</h5>
                <table class="table table-sm table-hover table-striped tableusers">
                    <thead>
                    <tr>
                        <th data-column-id="_id" data-visible="false">ID</th>
                        <th data-align="center" data-column-id="e" data-formatter="e" data-sortable="false" data-width="36px"></th>
    <!--                    <th data-align="center" data-column-id="x" data-formatter="x" data-sortable="false" data-width="36px"></th>-->
                        <th data-align="center" data-column-id="active" data-formatter="checkbox" data-width="36px"></th>
                        <th data-column-id="name" data-sortable="true" data-order="asc">Nome do usuário</th>
                        <th data-column-id="email" data-sortable="true" >E-mail do usuário</th>
                    </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {initGrid} from 'hennig-common'

export default {
    name: 'Users',
    mounted () {
        this.init()
    },
    methods: {
        init () {
            const addLabel = 'Novo usuário'
            const collectionObj = 'User'
            initGrid({
                container: $(this.$el).find('table'),
                collectionObj,
                rowClick: true,
                addLabel
            })
        }
    }
}
</script>

<style scoped>

</style>
